export default {
  data() {
    return {
      dialogNotification: false,
      detailDataForNotif: {},
      alertHistory: [],
      loadingAlerts: false,
      alertHeaders: [
        { text: "Time", value: "alerttime", sortable: true },
        { text: "Code", value: "alertcode", sortable: true },
        { text: "Message", value: "alertmessage", sortable: false },
      ],
    };
  },
  methods: {
    async handleNotificationClick(item) {
      if (!item || !item.devicecode) {
        this.$toast.error("Invalid device data for notification.");
        return;
      }

      this.detailDataForNotif = item;
      this.dialogNotification = true;
      this.loadingAlerts = true;
      this.alertHistory = [];

      try {
        // 1. Ambil riwayat alert dari backend
        const response = await this.$axios.get(
          `/spju/alerts/${item.devicecode}`
        );
        this.alertHistory = response.data.data;
      } catch (error) {
        console.error("Failed to fetch alert history (GET request):", error.response || error);
        this.$toast.error("Failed to load alert history.");
        this.loadingAlerts = false;
        return; // Hentikan eksekusi jika GET gagal
      }

      try {
        // 2. Jika ada alert yang belum dibaca, panggil API untuk menandainya
        // 2. Jika ada alert yang belum dibaca, panggil API untuk menandainya
        // User request: Jangan otomatis tandai sebagai terbaca saat dibuka.
        // Biarkan user yang menandainya secara manual (jika ada fitur itu) atau biarkan tetap unread
        // sampai logika lain menanganinya.
        /*
        if (item.unread_alerts > 0) {
          await this.$axios.post(`/spju/alerts/read/${item.devicecode}`);
          // Gunakan action Vuex untuk mengubah state secara benar.
          this.$store.dispatch(
            "devices/markDeviceAlertsAsRead",
            item.devicecode
          );
        }
        */
      } catch (error) {
        console.error("Failed to mark alerts as read (POST request):", error.response || error);
        // Jangan tampilkan toast error lagi agar tidak duplikat,
        // karena history sudah berhasil di-load.
        // Cukup log error di console.
      } finally {
        this.loadingAlerts = false;
      }
    },
    generateNotificationDialog() {
      // Fungsi ini bisa dipanggil di template komponen untuk membuat dialog
      // Ini adalah contoh, Anda bisa mengimplementasikannya lebih lanjut jika perlu
      // Untuk saat ini, kita akan menaruh template dialog langsung di setiap komponen
    }
  },
  computed: {
    unreadAlertsMap() {
      return this.$store.getters["devices/unreadAlerts"] || {};
    },
  },
};